import { render, staticRenderFns } from "./ImmobiliTable.vue?vue&type=template&id=0b6d82d4&scoped=true&"
import script from "./ImmobiliTable.vue?vue&type=script&lang=js&"
export * from "./ImmobiliTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d82d4",
  null
  
)

export default component.exports